module.exports = __webpack_public_path__ + "img/两面针.25b9a5a3.jpg";